<template>
  <div class="flex layout-column elevation-0 pa-1"
       style="border-radius: 6px;overflow-y: hidden"
       :style="{'background': compColor.lxExpansion.background}">

    <div class="flex layout-column">
      <lx-data-table-simple
        tableName="StatisticsList"
        :items="items"
        :headers="tableObj.headers"
        :loading="tableObj.loading"
        :preventRowClick="true"
        :hideContextFilter="true"
        :tableOptions="tableObj.options"
        :setHeightOnItems="true"
        @changeOptions="changeTableOptions">
      </lx-data-table-simple>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatisticsList',
  props: ['locationId', 'startDate', 'endDate', 'datesAreInvalid'],
  data () {
    return {
      items: [],
      tableObj: {
        loading: false, // benutzt während des GetDatas um eine Ladeanimation einzublenden
        options: {
          sortBy: ['creation_date'],
          sortDesc: [true],
        },
        selection: null,
        headers: [
          {
            text: this.$t('LIST_DIVERSE.CREATED_AT'),
            value: 'creation_date',
            sortable: true,
            width: '150px',
            renderer: 'date'
          },
          {
            text: this.$t('LIST_DIVERSE.COUNT_PATIENTS'),
            value: 'patients',
            class: 'text-center',
            bodyClass: 'text-center',
            sortable: true,
            width: '150px'
          },
          {
            text: this.$t('LIST_DIVERSE.COUNT_REPORT_FORMS'),
            value: 'forms',
            sortable: true
          }
        ]
      }
    }
  },
  created () {
    this.getDataForTable()
  },
  methods: {
    /**
     * React on changes of options in lx-data-table, set table-options in component and call getDataForTable
     */
    changeTableOptions (value) {
      if (value) {
        this.tableObj.options = value
      }
      this.getDataForTable()
    },

    getDataForTable () {
      // prevent request when date values are invalid or request already is running
      if (this.tableObj.loading || this.datesAreInvalid) return
      this.tableObj.loading = true

      let opts = {}

      if (this.tableObj.options && this.tableObj.options.sortBy && this.tableObj.options.sortBy.length > 0) {
        opts.sort = {}
        opts.sort[this.tableObj.options.sortBy[0]] = this.tableObj.options.sortDesc[0] ? -1 : 1
      }

      let query = {}

      if (this.startDate) {
        query.startDate = this.startDate
      }

      if (this.endDate) {
        query.endDate = this.endDate
      }

      this.$http.get('/statistics/getOverview/' + this.locationId + '?config={"opts":' + JSON.stringify(opts) + ', "query": ' + JSON.stringify(query) + '}')
        .then(res => {
          this.items = []

          if (res.data && Array.isArray(res.data.items)) {
            this.items = res.data.items
          }
        })
        .catch(this.NotifyError)
        .finally(() => {
          this.tableObj.loading = false
        })
    }
  },
  watch: {
    '$route' (to) {
      if (to.name === 'StatisticsList') {
        this.getDataForTable()
      }
    }
  }
}
</script>
